import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const FilePlus: BleskIcon = forwardRef(function Check(props, ref) {
  return (
    <BaseIcon viewBox="0 0 64 64" {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9934 16.8225L45.0131 10.8422C43.5128 9.34188 41.4779 8.49902 39.3562 8.49902H18.6699C14.2516 8.49902 10.6699 12.0807 10.6699 16.499V48.499C10.6699 52.9173 14.2516 56.499 18.6699 56.499H45.3366C49.7549 56.499 53.3366 52.9173 53.3366 48.499V22.4794C53.3366 20.3577 52.4937 18.3228 50.9934 16.8225Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0033 32.1758V43.4895"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.6614 37.8324H26.3477"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.3366 23.1657H44.0033C41.0577 23.1657 38.6699 20.7779 38.6699 17.8324V8.49902"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
